// @ts-nocheck
/* eslint-disable */
import { call, put, takeLatest } from 'redux-saga/effects';
import { HIDE_FULLSCREEN_LOADER, SHOW_FULLSCREEN_LOADER } from 'appRedux/actions/loader';
import { UPDATE_TAB_EDITED_STATE } from 'appRedux/actions/project_budget';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';
import {
  ADD_BULK_TASK_REQUEST,
  ADD_BULK_TASK_SUCCESS,
  DELETE_RESOURCE_REQUEST,
  DELETE_RESOURCE_ROW,
  DELETE_SUB_TASK_ROW,
  DELETE_SUBTASK_REQUEST,
  DELETE_TASK_REQUEST,
  DELETE_TASK_SUCCESS,
  GET_BULK_TASK_REQUEST,
  GET_BULK_TASK_SUCCESS,
  GET_DROPDOWN_RESOURCE_LIST_REQUEST,
  GET_DROPDOWN_RESOURCE_LIST_SUCCESS,
  GET_DROPDOWN_SUBTASK_LIST_REQUEST,
  GET_DROPDOWN_SUBTASK_LIST_SUCCESS,
  GET_DROPDOWN_TASK_LIST_REQUEST,
  GET_DROPDOWN_TASK_LIST_SUCCESS,
  UPDATE_TASK_NAME_REQUEST,
  UPDATE_TASK_NAME_SUCCESS,
} from '../constants/taskConstants';

function* addBulkTaskRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/task-sub_task-resource-bulk/?project_id=${payload.id}`,
    payload.task,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: UPDATE_TAB_EDITED_STATE, payload: { tabEdited: false } });
    yield put({ type: ADD_BULK_TASK_SUCCESS });
    successToast('Task was added successfully.');
  }
}

function* getBulkTaskRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/task-sub_task-resource-bulk/?project_id=${payload.project_id}&task_id=${payload.task_id}`,

    token,
  );

  if (data) {
    yield put({ type: GET_BULK_TASK_SUCCESS, payload: data });
  }
}

function* updateTaskNameRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/task-new/${payload.task_id}/?project_id=${payload.project}`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: UPDATE_TASK_NAME_SUCCESS, payload: data });

    successToast('Task Name was updated successfully.');
  }
}

function* deleteTaskRequest(action) {
  // yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/feature_delete/`,
    payload,
    token,
  );

  if (data) {
    yield put({
      type: DELETE_TASK_SUCCESS,
    });
    // yield put({ type: HIDE_FULLSCREEN_LOADER });
    successToast('Task was deleted successfully.');
  }
}

function* getDropdownTaskList(action) {
  const token = localStorage.getItem('token');
  const { project } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/task/?project_id=${project}`,
    token,
  );

  if (data) {
    yield put({ type: GET_DROPDOWN_TASK_LIST_SUCCESS, payload: data });
  }
}

function* getDropdownSubTaskList(action) {
  const token = localStorage.getItem('token');
  const { taskId } = action;
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/sub-task/?task_id=${taskId}`,

    token,
  );

  if (data) {
    yield put({ type: GET_DROPDOWN_SUBTASK_LIST_SUCCESS, payload: data });
  }
}

function* getDropdownResourceList(action) {
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/resource_rate/?${query}`,

    token,
  );

  if (data) {
    yield put({
      type: GET_DROPDOWN_RESOURCE_LIST_SUCCESS,
      payload: data,
    });
  }
}

function* deleteSubTaskRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchPostApi,

    `${API_URI}/delete-task/${payload.subTaskId}/`,

    token,
  );

  if (data) {
    yield put({
      type: DELETE_SUB_TASK_ROW,
      payload,
    });
  }
}

function* deleteResourceRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchPostApi,

    `${API_URI}/delete-resource/${payload.resrcId}/`,

    token,
  );

  if (data) {
    yield put({
      type: DELETE_RESOURCE_ROW,
      payload,
    });
  }
}

function* taskWatcher() {
  yield takeLatest(ADD_BULK_TASK_REQUEST, addBulkTaskRequest);

  yield takeLatest(GET_BULK_TASK_REQUEST, getBulkTaskRequest);

  yield takeLatest(UPDATE_TASK_NAME_REQUEST, updateTaskNameRequest);
  yield takeLatest(DELETE_TASK_REQUEST, deleteTaskRequest);

  yield takeLatest(GET_DROPDOWN_TASK_LIST_REQUEST, getDropdownTaskList);

  yield takeLatest(
    GET_DROPDOWN_SUBTASK_LIST_REQUEST,
    getDropdownSubTaskList,
  );

  yield takeLatest(
    GET_DROPDOWN_RESOURCE_LIST_REQUEST,
    getDropdownResourceList,
  );
  yield takeLatest(DELETE_SUBTASK_REQUEST, deleteSubTaskRequest);
  yield takeLatest(DELETE_RESOURCE_REQUEST, deleteResourceRequest);
}

export default taskWatcher;
